import { UIText1, UIText2, useDeviceType } from '@cian/ui-kit';

export const useResponsiveText = () => {
  const deviceType = useDeviceType();
  const isPhone = deviceType === 'phone';

  return isPhone ? UIText2 : UIText1;
};
